<template>
  <el-dialog
      :visible.sync="isShow"
      width="800px"
      class="linkAllDialog"
      :title="title"
      :close-on-click-modal="false"
      top="12vh">
    <!--  -->
    <div style="display: flex">
      <el-select
          v-model="squadUuid"
          style="margin-bottom:20px;"
          clearable
          @change="changeQuery(true)"
      >
        <el-option label="全部球队" value=""></el-option>
        <el-option
            v-for="(item, index) in squardList"
            :key="index"
            :label="item.shortName"
            :value="item.uuid"></el-option>
      </el-select>
      <el-input
          v-model="seacherString"
          type="text"
          class="yioks_input"
          style="width: 160px;margin-left: 10px"
          placeholder="请输入关键字"
          @keyup.enter="changeQuery(true)"
      />
      <div class="yioks_btn" style="height: 40px;color: #fff;" @click="changeQuery(true)">搜索</div>
    </div>

    <div class="sss" style="height: 530px;padding-bottom: 10px">
      <template>
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:460px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 460px">
            <div class="th" style="margin-right: 20px">
              <div class="tr img" style="border-left: 1px solid gray">
                <p>头像</p>
              </div>
              <div class="tr name">
                <p>姓名</p>
              </div>
              <div class="tr organName">
                <p>所属球队</p>
              </div>
              <div class="tr idNumber">
                <p>身份证号</p>
              </div>
              <div class="tr choose" >
                <p>
                  全选
                  <el-checkbox v-model="checkedAll"  @change="changeAllBox"></el-checkbox>
                </p>
              </div>
            </div>
            <div style="height: 420px" class="scollContent">
              <vue-scroll :ops="ops">
                <div class="list" style="margin-right: 20px">
                  <div v-for="(item,index) in playerList" :key="item.id" class="tbody">
                    <div class="td img" style="border-left: 1px solid gray">
                      <img
                          :src="item.headImgUrl ? item.headImgUrl : person"
                          alt=""
                          style="width:45px;height:45px;border-radius:50%;"
                          @error="item.headImgUrl = person">
                    </div>
                    <div class="td name">
                      <p>{{item.idName}}</p>
                    </div>
                    <div class="td organName">
                      <p :title="item.workName">{{item.workName}}</p>
                    </div>
                    <div class="td idNumber">
                      <p>{{ item.idNumber | filterIdNumberPrivacy }}</p>
                    </div>
                    <div class="td choose" >
                      <el-checkbox v-model="item.checked" fill="#4cd964" @change="changeBox(item.checked,index)"></el-checkbox>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <div>
            <page-small :pageSize="pageSize" :page.sync="page" :total="total"></page-small>
          </div>
          <template v-if="Object.keys(linkObj).length > 0">
            <div style="display: flex;justify-content: center;align-items: center;">
              <p>已选择{{Object.keys(linkObj).length}}人</p>
              <el-button
                  type="primary"
                  size="mini"
                  style="margin-left: 15px"
                  @click="isShow=false">关闭</el-button>
            </div>
          </template>
        </template>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import player from '@/api/player'
import person from '@/assets/images/common/person.jpg'
export default {
  name: 'index',
  components: {
    'page-small': () => import('@/components/layout/SmallPage.vue')
  },
  props: {
    type: {
      required: true, // 传入类型
      type: String
    },
    obj: {
      required: false, // 用来判断回显选中的
      type: Object
    },
    organUuid: {
      required: true,
      type: String
    },
    youthUuid: {
      required: true,
      type: String
    },
    showDialog: {
      required: true,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    squardList: {
      type: Array
    }
  },
  data () {
    return {
      ops,
      checkedAll: false,
      count: 0,
      person,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      playerList: [ ],
      linkObj: { },
      page: 0,
      pageSize: 20,
      loading: true,
      empty: false,
      total: 0,
      disabled: false,
      squadUuid: '',
      seacherString: ''
    }
  },
  computed: {
    isShow: {
      get () {
        return this.showDialog
      },
      set (val) {
        this.$emit('update:showDialog', val)
      }
    }
  },
  watch: {
    page(val) {
      /* 处理分页 */
      this.getPlayerList()
    }
  },
  created () {
    if (Object.keys(this.obj).length > 0) {
      this.linkObj = { ...this.linkObj, ...this.obj }
    }
    this.changeQuery(true)
  },
  methods: {
    changeQuery(flag) {
      if(flag) this.page = 0;
      this.getPlayerList()
    },
    requestPlayer () {
      let request
      request = player.getPlayerYouth
      request({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize
      }).then(res => {
        if (res.content.length === 0) {
          this.disabled = true
        } else {
          const list = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.playerList = this.playerList.concat(list)
        }
      }).catch(() => {
        this.disabled = true
      })
    },
    load () {
      this.page += 1
      if (this.page > Math.floor(this.total / this.pageSize)) {
        return
      }
      this.requestPlayer()
    },
    getPlayerList () {
      this.loading = true
      let request = player.getPlayerYouth
      request({
        organUuid: this.organUuid,
        youthUuid: this.youthUuid,
        page: this.page,
        size: this.pageSize,
        squadUuid: this.squadUuid,
        seacherString: this.seacherString,
      }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
          this.total = res.totalElements
        } else {
          this.empty = false
          this.playerList = res.content.map(item => {
            if (this.linkObj[item.uuid]) {
              item.checked = true
            }
            return item
          })
          this.total = res.totalElements
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 选择一个
    changeBox (val, index) {
      this.$set(this.playerList[index], 'checked', val)
      if (val) {
        this.linkObj[this.playerList[index].uuid] = this.playerList[index]
        this.$emit('hideDialog', this.linkObj, this.type)
        // 选中某一项时遍历列表假如全部选中就修改全部选中的状态为true
        this.checkedAll = this.playerList.every(item => {
          return item.checked
        })
      } else {
        delete this.linkObj[this.playerList[index].uuid]
        this.$emit('hideDialog', this.linkObj, this.type)
        // 取消选中某一项时修改全部选中的状态为false
        this.checkedAll = false
      }
    },
    // 选择多个
    changeAllBox (val) {
      if (val) {
        this.playerList.map(item => {
          this.$set(item, 'checked', true)
          this.linkObj[item.uuid] = item
          return item
        })
      } else {
        this.playerList.map(item => {
          this.$set(item, 'checked', false)
          return item
        })
        this.linkObj = {}
      }
      this.$emit('hideDialog', this.linkObj, this.type)
    },
    add (index) {
      this.$set(this.playerList[index], 'checked', true)
      this.linkObj[this.playerList[index].uuid] = this.type
      this.$emit('hideDialog', this.linkObj, this.type)
    },
    remove (index) {
      this.$set(this.playerList[index], 'checked', false)
      delete this.linkObj[this.playerList[index].uuid]
      this.$emit('hideDialog', this.linkObj, this.type)
    },
    checkForm () {
      this.$emit('hideDialog', this.linkObj, this.type)
    }
  }
}
</script>

<style  lang="stylus">
@import '~@/assets/css/variable'
.linkAllDialog
  .el-dialog__body
    padding  15px 20px
  .th
    display flex
    height:40px
    justify-content: center;
    align-items: center;
    border-bottom 1px solid gray
    border-top 1px solid gray
    .tr
      height 100%
      flex  1  1 auto
      border-right 1px solid gray
      display flex
      justify-content center
      align-items center
      p
        text-align center
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: black;
    .choose
      width 15%
    .name
      width 15%
    .img
      width 10%
    .organName
      width 20%
    .youthName
      width 20%
    .idNumber
      width 20%
    .opt
      width 15%
  .tbody
    display: flex
    justify-content center
    align-items center
    border-bottom 1px solid gray
    height 49px
    .td
      border-right 1px solid gray
      height 100%
      flex  1  1 auto
      display flex
      justify-content center
      align-items center
      p
        text-align center
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: black;
    .choose
      width 15%
    .name
      width 15%
    .img
      width 10%
    .organName
      width 20%
    .youthName
      width 20%
    .idNumber
      width 20%
    .opt
      width 15%
  .el-pagination
    color black
    .el-pagination__total,.el-pagination__jump
      color black
    .btn-prev,.btn-next
      color black
    ul > li
      color black
    ul > li:hover
      color $green_color
    ul > li.active
      color  $green_color
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: $green_color;
  border-color: $green_color;
}
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.tutorial
  color #999
  font-size 16px
  .item
    padding 10px 0
    border-bottom 1px solid #CCC
    margin 0 20px
    .title
      padding 10px 0 25px 0
      font-size 20px
      font-weight bold
      color #000
    .info_content
      display flex
      img
        width 207px
        height 121px
        margin-right 25px
      .info
        display flex
        flex-direction column
        justify-content center
        flex 1
        p
          margin-bottom 10px
      .btn_wrap
        margin-right 40px
        .btn
          margin-top 10px
          text-align center
</style>
